export const STOCKS = [1, 10, 30];
